import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {DialogConfig} from "../../../../../core/components/dialog/dialog-config";
import {DialogRef} from "../../../../../core/components/dialog/dialog-ref";
import {
  ProtocolFindFascicoloRequest
} from "../../../models/dto/protocol-fascicolo";
import {ProtocolError} from "../../../models/protocol";
import { RequestProtocol } from '../../../models/dto/request-fascicolo-protocol';
import {ProtocolStore} from "../../../stores/protocol-store";
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';

@Component({
  selector: 'app-protocol-fascicolo-dialog',
  templateUrl: './protocol-fascicolo-dialog.component.html',
  styleUrls: ['./protocol-fascicolo-dialog.component.css']
})
export class ProtocolFascicoloDialogComponent implements OnInit {

  protected activeTab: number = ProtocolStore.getDialogActiveTab();
  fascicolo:FascicoloFull;
  praticaId:string;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private cdr: ChangeDetectorRef
  ) {
  }

  public ngOnInit() {
    console.log("[ngOnInit]");
    this.fascicolo = this.dialogConfig.data.fascicolo;
    this.praticaId = this.dialogConfig.data.idPratica;
  }

  protected setActiveTab(index: number) {
    this.activeTab = index;
    ProtocolStore.setDialogActiveTab(this.activeTab);
    this.cdr.detectChanges();
  }

  protected doError(response: ProtocolError | any) {
    console.log("[onError]", response);
  }

  protected doSearch(response: ProtocolFindFascicoloRequest) {
    console.log("[onSearch]", response);
    this.dialogRef.close(response);
  }

  protected doImport(response: ProtocolFindFascicoloRequest) {
    this.dialogRef.close(response);
    let obj = {action: "IMPORT", response: response, fascicolo: this.fascicolo , praticaId: this.praticaId};
    this.dialogRef.close(obj);
  }

  protected doInsert(response: RequestProtocol) {
    let obj = {action: "INSERT", response: response};
    this.dialogRef.close(obj);
  }

  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    if (key === 'ArrowRight') this.setActiveTab((this.activeTab + 1) % 2);
    if (key === 'ArrowLeft') this.setActiveTab((this.activeTab + 1) % 2);
  }

 
}
